import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './index.scss';
import Gateway from "./pages/gateway/gateway";
import Threedsv from './pages/3dsv/threedsv';
import { ToastContainer } from "react-toastify";
import Transfer from './pages/transfer/transfer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <ToastContainer />
    <BrowserRouter>
      <Routes>
        <Route path="credit-card/:env/:txnId" element={<Gateway />}></Route>
        <Route path="purchase-3dsv/:txid" element={<Threedsv />}></Route>
        <Route path="transfer/:env/:txnId" element={<Transfer />}></Route>
      </Routes>
    </BrowserRouter>
  </>
);

